import { Component, OnInit,HostListener } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import { HelperService } from '../helper.service';
import { Http, Response,Headers } from '@angular/http';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
   providers: [HelperService,CookieService] 
})
export class SidebarComponent implements OnInit {
  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
class_value:String="active";

user_permissions:any=[];
user_expand='false';
user_collapse='collapse';
report_expand='false';
report_collapse='collapse';
package_expand='false';
package_collapse='collapse';
contentmanage_expand='collapse';
contentmanage_collapse='collapse';


url='';
class1 :String="";
class2 :String="";
class3 :String="";
class4 :String="";
class5 :String="";
class6 :String="";
class7 :String="";
class8 :String="";
class9 :String="";
class10 :String="";
class11 :String="";
class12:String="";
class13:String="";
class14:String="";
user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private router: Router,private cookie:CookieService,private helper:HelperService,private http:Http){
    this.url=this.router.url;
    if(this.router.url === '/dashboard'){
      this.class1=this.class_value;
      this.class2="";
      this.class3="";
      this.class4="";
      this.class5="";
      this.class6="";
      this.class7="";
      this.class8="";
       this.class9="";
       this.class11="";
       this.class12="";
       this.class13="";
       this.class14="";
    }else if(this.router.url === '/users' || this.router.url === '/roles' || this.router.url === '/permissions'){
   
      this.class2=this.class_value;
      this.class1="";
      this.class3="";
      this.class4="";
      this.class5="";
      this.class6="";
      this.class7="";
      this.class8="";
       this.class9="";
       this.class11="";
       this.class12="";
        this.class13="";
        this.class14="";
        this.user_expand='true';
  this.user_collapse='collapse in';
    }else if(this.router.url.indexOf('/appusers') > -1 || this.router.url.indexOf('/address') > -1 || this.router.url.indexOf('/unblock') > -1){
   
      this.class2="";
      this.class1="";
      this.class3=this.class_value;
      this.class4="";
      this.class5="";
      this.class6="";
      this.class7="";
      this.class8="";
       this.class9="";
       this.class11="";
       this.class12="";
        this.class13="";
        this.class14="";
    }else if(this.router.url.indexOf('/student') > -1 ){
       this.class2="";
      this.class1="";
      this.class3=this.class_value;
      this.class4="";
      this.class5="";
      this.class6="";
      this.class7="";
      this.class8="";
       this.class9="";
       this.class11="";
       this.class12="";
        this.class13="";
        this.class14="";
    }else if(this.router.url.indexOf('/record') > -1 || this.router.url.indexOf('/grade') > -1 || this.router.url.indexOf('/subject') > -1 || this.router.url.indexOf('/chapters') > -1 || this.router.url.indexOf('/topics') > -1 || this.router.url.indexOf('/vedio') > -1 || this.router.url.indexOf('/topictest') > -1 || this.router.url.indexOf('/chaptertest') > -1 || this.router.url.indexOf('/subject_paper') > -1){
   
      this.class2="";
      this.class1="";
      this.class3="";
      this.class4=this.class_value;
      this.class5="";
      this.class6="";
      this.class7="";
      this.class8="";
       this.class9="";
       this.class11="";
       this.class12="";
        this.class13="";
        this.class14="";
    }else if(this.router.url.indexOf('/coupons') > -1){
      this.class3="";
      this.class2="";
      this.class1="";
      this.class4="";
      this.class5=this.class_value;
      this.class6="";
      this.class7="";
      this.class8="";
       this.class9="";
       this.class11="";
       this.class12="";
        this.class13="";
        this.class14="";
    }else if(this.router.url.indexOf('/notification') > -1 || this.router.url.indexOf('/settings') > -1){
      this.class6=this.class_value;
      this.class2="";
      this.class3="";
      this.class1="";
      this.class5="";
      this.class4="";
      this.class7="";
      this.class8="";
       this.class9="";
       this.class11="";
       this.class12="";
        this.class13="";
        this.class14="";
        this.contentmanage_expand='true';
    this.contentmanage_collapse='collapse in';
    }else if(this.router.url.indexOf('/experts_subject') > -1){
      this.class7=this.class_value;
      this.class2="";
      this.class3="";
      this.class1="";
      this.class5="";
      this.class4="";
     this.class9="";
       this.class6="";
       this.class11="";
      this.class8="";
      this.class12="";
       this.class13="";
       this.class14="";
    }else if(this.router.url.indexOf('/subscription') > -1){
      this.class7="";
      this.class2="";
      this.class3="";
      this.class1="";
      this.class5="";
      this.class4="";
      this.class7="";
      this.class7="";
       this.class9=this.class_value;
       this.class11="";
       this.class12="";
        this.class13="";
      this.class8=this.class_value;
      this.class14="";
      this.package_expand='true';
  this.package_collapse='collapse in';
    }else if(this.router.url.indexOf('/notification') > -1){
      this.class7="";
      this.class2="";
      this.class3="";
      this.class1="";
      this.class5="";
      this.class4="";
      this.class7="";
      this.class7="";
      this.class8="";
      this.class12="";
       this.class13="";
this.class11="";
       this.class9=this.class_value;
       this.class14="";
    }else if(this.router.url.indexOf('/enquiries') > -1 || this.router.url.indexOf('/enquiryreply') > -1){
      this.class7="";
      this.class2="";
      this.class3="";
      this.class1="";
      this.class5="";
      this.class4="";
      this.class7="";
      this.class7="";
      this.class8="";
      this.class12="";
       this.class9="";
        this.class13="";
        this.class11=this.class_value;
        this.class14="";
    }else if(this.router.url.indexOf('/doubtlist') > -1 || this.router.url.indexOf('/doubtreply') > -1){
      this.class7="";
      this.class2="";
      this.class3="";
      this.class1="";
      this.class5="";
      this.class4="";
      this.class7="";
      this.class7="";
      this.class8="";
      this.class11="";
       this.class9="";
        this.class13="";
        this.class12=this.class_value;
        this.class14="";
    } else if(this.router.url.indexOf('/payments') > -1){
      this.class7="";
      this.class2="";
      this.class3="";
      this.class1="";
      this.class5="";
      this.class4="";
      this.class7="";
      this.class7="";
      this.class8="";
      this.class11="";
       this.class9="";
        this.class13=this.class_value;
        this.class12="";
        this.class14="";
    }else if(this.router.url.indexOf('/reports/tests')>-1 || this.router.url.indexOf('/reports/subscription') >-1 || this.router.url.indexOf('/reports/doubts') >-1 || this.router.url.indexOf('/reports/sales') >-1 || this.router.url.indexOf('/order') >-1 ){
      this.class7="";
      this.class2="";
      this.class3="";
      this.class1="";
      this.class5="";
      this.class4="";
      this.class7="";
      this.class7="";
      this.class8="";
      this.class11="";
       this.class10=this.class_value;
       this.class9="";
        this.class12="";
         this.class13="";
         this.class14="";
         this.report_expand='true';
  this.report_collapse='collapse in';
    }else{
      // this.class7="";
      // this.class2="";
      // this.class3="";
      // this.class1="";
      // this.class5="";
      // this.class4=this.class_value;
      // this.class7="";
      // this.class7="";
      // this.class8="";
      // this.class12="";
      //  this.class9="";
      //   this.class11="";
      //    this.class13="";
      //    this.class14="";
    }
   }

  ngOnInit() {
   let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
  }


user_click(event){
  if(this.user_expand=='true'){
   this.user_expand='false';
   this.user_collapse='collapse';
  }else{
   this.user_expand='true';
  this.user_collapse='collapse in';
  }
}
  report_click(event){
  if(this.report_expand=='true'){
   this.report_expand='false';
   this.report_collapse='collapse';
  }else{
   this.report_expand='true';
  this.report_collapse='collapse in';
  }
 }
 package_click(event){
  if(this.package_expand=='true'){
   this.package_expand='false';
   this.package_collapse='collapse';
  }else{
   this.package_expand='true';
  this.package_collapse='collapse in';
  }
}
  contentmanage_click(event){
    if(this.contentmanage_expand=='true'){
     this.contentmanage_expand='false';
     this.contentmanage_collapse='collapse';
    }else{
     this.contentmanage_expand='true';
    this.contentmanage_collapse='collapse in';
    }
  }

  
  
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.ts